"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseVideoItem = void 0;
const common_1 = require("@wix/wix-vod-shared/common");
const common_2 = require("@wix/wix-vod-constants/common");
const entity_id_1 = require("../normalizers/entity-id");
const api_types_1 = require("@wix/wix-vod-constants/api-types");
const mapMediaInfoToLiveStatus_1 = require("@wix/wix-vod-api-site-based/dist/src/utils/mapMediaInfoToLiveStatus");
const DEFAULT_DOWNLOAD_OPTIONS = { allowDownload: false };
const normalizeTranscodingStatus = (status) => {
    if (_.includes(common_2.TRANSCODING_STATUSES, status)) {
        return status;
    }
    return common_2.TRANSCODING_STATUSES.NONE;
};
const mapUsedInLists = (usedInLists = []) => usedInLists.map((ref) => ({
    id: ref.itemId,
    title: ref.title,
}));
const parseVideoItem = (itemData) => {
    var _a;
    const camelCasedItemData = (0, common_1.keysToCamelCase)(itemData);
    const { itemId, externalId, listId, mediaStatus, trailerStatus, mediaInfo, mediaExternUrl, downloadOptions: { allowDownload } = DEFAULT_DOWNLOAD_OPTIONS, videoSource = common_2.VIDEO_SOURCES.COMPUTER, itemType, } = camelCasedItemData;
    const id = (itemId && (0, entity_id_1.normalizeId)(itemId)) || externalId;
    const { customCoverUrl = null, createdTs: createdTsNum, updatedTs: updatedTsNum, publishTs: publishTsNum, usedInLists, } = camelCasedItemData;
    let { dealInfo, durationSec, durationStr, tags = [], categories = [], } = camelCasedItemData;
    const createdTs = new Date(createdTsNum * 1000);
    const updatedTs = new Date(updatedTsNum * 1000);
    const publishTs = publishTsNum ? new Date(publishTsNum * 1000) : null;
    const fileInputDurationSec = _.get(mediaInfo, 'fileInput.duration', 0);
    if (fileInputDurationSec) {
        durationSec = Math.floor(fileInputDurationSec / 1000);
        durationStr = (0, common_1.convertSSToMMSS)(durationSec);
    }
    if (!durationStr) {
        durationStr = (0, common_1.convertSSToMMSS)(durationSec);
    }
    const transcodingStatus = normalizeTranscodingStatus(mediaExternUrl ? common_2.TRANSCODING_STATUSES.READY : mediaStatus);
    const trailerTranscodingStatus = normalizeTranscodingStatus(trailerStatus);
    // external videos should be free
    if (mediaExternUrl) {
        dealInfo = common_2.FREE_VIDEO_DEAL_INFO;
    }
    tags = _.uniq(tags);
    categories = _.uniq(categories);
    const normalizedListId = (0, entity_id_1.normalizeId)(listId);
    const clearCamelCasedItemData = _.omit(camelCasedItemData, [
        'downloadOptions',
        'mediaStatus',
        'trailerStatus',
    ]);
    const mapAutogeneratedTrailerInfo = () => {
        const status = normalizeTranscodingStatus(mediaInfo.fileOutput.trailer[0].status);
        if (status === common_2.TRANSCODING_STATUSES.FAILED) {
            return {
                status,
                errorType: api_types_1.TrailerGenerationErrorType.InternalError,
            };
        }
        else {
            return { status };
        }
    };
    const mappedCamelCasedItemData = Object.assign(Object.assign({}, clearCamelCasedItemData), { id, listId: normalizedListId, customCoverUrl,
        transcodingStatus,
        trailerTranscodingStatus,
        dealInfo,
        durationSec,
        durationStr,
        createdTs,
        updatedTs,
        publishTs, usedInLists: mapUsedInLists(usedInLists), allowDownload,
        videoSource,
        tags,
        categories, liveVideoStatus: (0, mapMediaInfoToLiveStatus_1.mapMediaInfoToLiveVideoStatus)(mediaInfo, itemType), autogeneratedTrailer: ((_a = mediaInfo === null || mediaInfo === void 0 ? void 0 : mediaInfo.fileOutput) === null || _a === void 0 ? void 0 : _a.trailer)
            ? mapAutogeneratedTrailerInfo()
            : undefined });
    return (0, common_1.removeUndefinedValues)(mappedCamelCasedItemData);
};
exports.parseVideoItem = parseVideoItem;
//# sourceMappingURL=video-item.js.map